import { AbstractDialogData } from '@next/core-lib/dialog';

export enum DownyMildewObservationSeverity {
  Spot = 'Spot',
  SingleShoot = 'SingleShoot',
}

export interface DownyMildewObservationRegistrationRequest {
  cropFieldIds: number[];
  observationDate: string;
  severity: DownyMildewObservationSeverity;
}

export interface DownyMildewObservationRemovalRequest {
  cropFieldId: number;
  observationId: number;
}

export interface DownyMildewObservationRegistration {
  id: number;
  cropFieldId: number;
  observationDate: string;
  severity: DownyMildewObservationSeverity;
  createdAt: string;
}

export interface DownyMildewObservationRegistrationsResponse {
  observationRegistrations: DownyMildewObservationRegistration[];
}

export interface DownyMildewObservationDialogData extends AbstractDialogData {
  cropFields: DownyMildewObservationCropField[];
  actionDate: Date;
  cropYear: number;
  readOnly?: boolean;
}

export interface DownyMildewObservationCropField {
  cropFieldId: number;
  cropFieldName: string;
  areaInHectares: number;
}
